module.exports = __webpack_public_path__ + "img/logo.b5f29070.png";